// 视频类分类直接用合集里一条 YouTube 视频的封面
const youtubeCover = videoId => `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`

const categories = [
  {
    id: 'ielts',
    seoName: 'IELTS listening',
    collectionSeoName: 'Cambridge {title} Listening',
    seoNameZh: '雅思听力',
    collectionSeoNameZh: '剑桥雅思 {id} 听力',
    // 每册按套题分页（/material/ielts/12/test-5）。素材 id 里的套题序号从 1 开始，
    // 剑 12 的真题编号是 Test 5–8，所以这一册从 5 起算
    tests: {
      firstTestNumber: { 12: 5 },
      // 雅思听力每套题 4 个 Section 的固定题型，用在套题页的列表里
      sectionTypes: [
        'An everyday conversation between two speakers',
        'A talk by one speaker on an everyday topic',
        'A discussion in a study or training setting',
        'A talk or lecture on an academic subject'
      ],
      sectionTypesZh: [
        '两人之间的日常生活对话',
        '一个人就日常话题做的讲话',
        '学习或培训场景下的多人讨论',
        '学术主题的讲座或讲话'
      ]
    },
    titleKey: 'material.ieltsTitle',
    descriptionKey: 'material.ieltsDesc',
    image: require('@/assets/material/ielts.png'),
    sortOrder: 10,
    defaultPrice: 50
  },
  {
    id: 'podcasts',
    seoName: 'podcast listening',
    collectionSeoName: '{title} Podcast',
    seoNameZh: '英语播客',
    collectionSeoNameZh: '{title} 英语播客',
    titleKey: 'material.podcastsTitle',
    descriptionKey: 'material.podcastsDesc',
    image: require('@/assets/material/podcasts.jpg'),
    sortOrder: 20,
    defaultPrice: 50
  },
  {
    id: 'ListeningLessonsbyLevel',
    seoName: 'listening lessons by level',
    collectionSeoName: '{title} English Listening Lessons',
    seoNameZh: '分级英语听力',
    collectionSeoNameZh: '{title} 分级英语听力',
    titleKey: 'material.listeningLessonsByLevelTitle',
    descriptionKey: 'material.listeningLessonsByLevelDesc',
    image: require('@/assets/material/listening-lessons-by-level.jpg'),
    sortOrder: 21,
    defaultPrice: 30
  },
  {
    id: 'NaturalEnglishConversations',
    seoName: 'natural English conversation',
    collectionSeoName: 'Everyday English Conversations {title}',
    seoNameZh: '日常英语对话',
    collectionSeoNameZh: '日常英语对话 {title}',
    titleKey: 'material.naturalEnglishConversationsTitle',
    descriptionKey: 'material.naturalEnglishConversationsDesc',
    image: require('@/assets/material/natural-english-conversation.jpg'),
    sortOrder: 22,
    defaultPrice: 30
  },
  {
    id: 'audiobooksadults',
    seoName: 'audiobook',
    collectionSeoName: '{title} Audiobook',
    seoNameZh: '英文有声书',
    collectionSeoNameZh: '{title} 英文有声书',
    titleKey: 'material.audiobooksadultsTitle',
    descriptionKey: 'material.audiobooksadultsDesc',
    image: require('@/assets/material/audiobooksadults.jpg'),
    sortOrder: 30,
    defaultPrice: 50
  },
  {
    id: 'teded',
    seoName: 'TED-Ed',
    collectionSeoName: '{title} Lessons',
    seoNameZh: 'TED-Ed 英语听力',
    collectionSeoNameZh: '{title} 英语听力',
    titleKey: 'material.tededTitle',
    descriptionKey: 'material.tededDesc',
    image: youtubeCover('idrbwnWLJ7w'),
    sortOrder: 525,
    defaultPrice: 50
  },
  {
    id: 'bbc6minute',
    seoName: 'BBC 6 Minute English',
    collectionSeoName: '{title}',
    seoNameZh: 'BBC 六分钟英语',
    collectionSeoNameZh: 'BBC 六分钟英语（6 Minute English）',
    titleKey: 'material.bbc6minuteTitle',
    descriptionKey: 'material.bbc6minuteDesc',
    image: youtubeCover('YAsDeXcYyTg'),
    sortOrder: 515,
    defaultPrice: 50
  },
  {
    id: 'toefl',
    seoName: 'TOEFL listening',
    collectionSeoName: '{title} Listening',
    seoNameZh: '托福听力',
    collectionSeoNameZh: '{title} 托福听力',
    titleKey: 'material.toeflTitle',
    descriptionKey: 'material.toeflDesc',
    image: require('@/assets/material/toefl.jpg'),
    sortOrder: 60,
    defaultPrice: 50
  },
  {
    id: 'youtube-beginner',
    seoName: 'slow English YouTube',
    collectionSeoName: '{title} Videos',
    seoNameZh: '慢速英语视频',
    collectionSeoNameZh: '{title} 慢速英语视频',
    titleKey: 'material.youtubeBeginnerTitle',
    descriptionKey: 'material.youtubeBeginnerDesc',
    image: youtubeCover('52t241OQ7Ec'),
    sortOrder: 300,
    defaultPrice: 50
  },
  {
    id: 'youtube-real-life',
    seoName: 'real-life English YouTube',
    collectionSeoName: '{title} Videos',
    seoNameZh: '生活场景英语视频',
    collectionSeoNameZh: '{title} 英语视频',
    titleKey: 'material.youtubeRealLifeTitle',
    descriptionKey: 'material.youtubeRealLifeDesc',
    image: youtubeCover('jhEtBuuYNj4'),
    sortOrder: 310,
    defaultPrice: 50
  },
  {
    id: 'youtube-vlog',
    seoName: 'everyday English vlog',
    collectionSeoName: '{title} Vlogs',
    seoNameZh: '英语 Vlog',
    collectionSeoNameZh: '{title} 英语 Vlog',
    titleKey: 'material.youtubeVlogTitle',
    descriptionKey: 'material.youtubeVlogDesc',
    image: youtubeCover('Pz68t3RGeqI'),
    sortOrder: 320,
    defaultPrice: 50
  }
]

const collectionsByCategory = {
  ielts: Array.from({ length: 16 }, (_, index) => {
    const book = 20 - index
    return {
      id: book,
      title: `IELTS ${book}`,
      sortOrder: index + 1
    }
  }),
  toefl: [
    { id: 'conversation', title: 'TOEFL conversation', sortOrder: 1 },
    { id: 'lecture', title: 'TOEFL lecture', sortOrder: 2 }
  ],
  audiobooksadults: [
    { id: 'atomichabits', title: 'Atomic Habits', sortOrder: 1 }
  ],
  podcasts: [
    { id: 'englishpod365', title: 'EnglishPod365', sortOrder: 1 },
    { id: 'englishpod365dg', title: 'EnglishPod365 Dialogue', sortOrder: 2, price: 30 }
  ],
  bbc6minute: [
    { id: 'bbc6minute', title: 'BBC 6 Minute English', sortOrder: 1 }
  ],
  teded: [
    { id: 'teded', title: 'TED Ed', sortOrder: 1 }
  ]
}

export function getFallbackCategories(t) {
  return categories.map(category => ({
    ...category,
    title: t ? t(category.titleKey) : category.titleKey,
    description: t ? t(category.descriptionKey) : category.descriptionKey,
    enabled: true
  }))
}

export function getFallbackCategory(categoryId, t) {
  return getFallbackCategories(t).find(category => category.id === categoryId)
}

export function getFallbackCollections(categoryId) {
  return (collectionsByCategory[categoryId] || []).map(collection => ({
    categoryId,
    enabled: true,
    ...collection
  }))
}

export function getFallbackMaterialPrice(categoryId, collectionId, item = {}) {
  if (item.price) return item.price
  const collection = getFallbackCollections(categoryId).find(entry => entry.id === collectionId)
  return collection?.price || getFallbackCategory(categoryId)?.defaultPrice || 50
}
